import { render, staticRenderFns } from "./SuccessfulOrder.vue?vue&type=template&id=77d18aa8&scoped=true"
import script from "./SuccessfulOrder.vue?vue&type=script&lang=js"
export * from "./SuccessfulOrder.vue?vue&type=script&lang=js"
import style0 from "./SuccessfulOrder.vue?vue&type=style&index=0&id=77d18aa8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77d18aa8",
  null
  
)

export default component.exports